import Header from "./Components/Header";
import { CLASS_BOOKING } from "../../assets/asset";
import { useNavigate } from "react-router-dom";
import PageContainer from "./Components/PageContainer";
import MainContent from "./Components/MainContent";
import BackButton from "./Components/BackButton";
import TutorProfileCard from "./Components/TutorProfileCard";
import QualificationsCard from "./Components/QualificationsCard";
import SpecializationsCard from "./Components/SpecializationsCard";
import TutorSidebar from "./Components/TutorSidebar";

const TutorDetails = () => {
  const navigate = useNavigate();

  const tutor = {
    id: 1,
    name: "Sarah Mitchell",
    rating: 4.9,
    reviews: 127,
    experience: "8 years experience",
    description:
      "Experienced mathematics tutor specializing in building strong foundations and confidence in maths. Experienced mathematics tutor specializing in building strong foundations and confidence in maths.",
    years: ["Year 2", "Year 3", "Year 6"],
    price: 65,
    image: "https://i.pravatar.cc/300?img=47",

    qualifications: [
      "Bachelor of Education",
      "NSW Teacher Registration",
      "Working with Children Check",
    ],

    specializations: [
      "Visual learning",
      "Exam preparation",
    ],

    topicsTaught: ["Fractions", "Algebra", "Geometry"],
  };

  const handleBookSession = () => {
    navigate("/classBooking/booking");
  };

  return (
    <PageContainer>
      <div className="sticky top-0 z-50 bg-[#DFF2EB]/70 backdrop-blur-md">
        <Header />
      </div>

      <MainContent>
        <BackButton onClick={() => window.history.back()} label="Back to Browse" />

        <div className="grid grid-cols-3 gap-10">
          <div className="col-span-2">
            <TutorProfileCard tutor={tutor} />
            <QualificationsCard qualifications={tutor.qualifications} />
            <SpecializationsCard specializations={tutor.specializations} />
          </div>

          <div className="col-span-1">
            <TutorSidebar 
              tutor={tutor} 
              topicsTaught={tutor.topicsTaught}
              onBookSession={handleBookSession}
            />
          </div>
        </div>
      </MainContent>
    </PageContainer>
  );
};

export default TutorDetails;
